export function cleanObjects(obj = {}) {
  return Object.entries(obj).reduce((tmp, [key, val]) => {
    if (Array.isArray(val) ? val.length : val) {
      tmp[key] = val
    }
    return tmp
  }, {})
}
